var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-5 pa-10",attrs:{"elevation":"3","rounded":"xl","outlined":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }